export enum StatusEnum {
  // 新工单
  NEW = 1,
  // 受理中
  ENTERTAINING = 2,
  // 已完成
  FINISH = 3,
  // 已关闭
  CLOSE = 4,
  // 已评分
  SCORE = 5,
}

export enum TicketTopEnum {
  // 置顶
  TOP = 1,
  // 非置顶
  UNTOP = 0,
}
